import {
  Card,
  CardContent,
  Tooltip,
  Typography
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useGetSessionQuery } from '../services/api';

export function VideoRequirementsCard({
  guid
}: {
  guid?: string;
}) {
  const { data: session } = useGetSessionQuery(guid);
  if (!session?.videoRequired)
    return null;

  return (
    <Card
      style={{
        marginTop: 10,
      }}
    >
      <CardContent>
        <Typography gutterBottom
        >This session requires that your video camera remain on. Therefore, the video off feature will be disabled.
          <Tooltip title="Practitioners determine whether a particular session requires video or not. That decision, as all decisions with Sessions, are made to help further create a safe environment for our Members.">
            <InfoIcon
              fontSize='small'
              style={{
                position: 'relative',
                top: 4
              }}
            />
          </Tooltip>
        </Typography>
      </CardContent>
    </Card>
  );
}
